import React from 'react';
import { Table, TableHeader, TableBody, TableRow, TableCell } from '../UI/Table';
import './SummarySection.css';

const SummarySection = ({ summaryData }) => {
    if (!summaryData || summaryData.length === 0) {
        return null;
    }

    // Separate regular rows and total row
    const regularRows = summaryData.filter(row => row.requestType !== 'Total');
    const totalRow = summaryData.find(row => row.requestType === 'Total');

    return (
        <div className="summary-section">
            <h2 className="summary-section__title">Fund Requests Summary</h2>
            <div className="summary-section__table">
                <Table>
                    <TableHeader>
                        <TableCell header>Request Type</TableCell>
                        <TableCell header>Total Requests</TableCell>
                        <TableCell header>Total Requests Amount</TableCell>
                    </TableHeader>
                    <TableBody>
                        {regularRows.map((row, index) => (
                            <TableRow key={index} className="summary-row">
                                <TableCell className="summary-row__type">
                                    {row.requestType}
                                </TableCell>
                                <TableCell className="summary-row__count">
                                    {row.totalRequests.toLocaleString()}
                                </TableCell>
                                <TableCell className="summary-row__amount">
                                    ${row.totalAmount.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                </TableCell>
                            </TableRow>
                        ))}
                        {totalRow && (
                            <TableRow className="summary-row summary-row--total">
                                <TableCell className="summary-row__type summary-row__type--total">
                                    <strong>{totalRow.requestType}</strong>
                                </TableCell>
                                <TableCell className="summary-row__count summary-row__count--total">
                                    <strong>{totalRow.totalRequests.toLocaleString()}</strong>
                                </TableCell>
                                <TableCell className="summary-row__amount summary-row__amount--total">
                                    <strong>
                                        ${totalRow.totalAmount.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}
                                    </strong>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

export default SummarySection;